module.exports = __webpack_public_path__ + "static/media/voala_loading.a1d1505a.png";